import { useEffect, useRef } from 'react';
import { ReactComponent as CheckIcon } from '../../../assets/icons/checkmark.svg';
import styles from './textEditable.module.scss';

const TextEditable = (props: {
    value: string;
    placeholder?: string;
    maxLength?: number;
    handleChange?: any;
    handleKeyDown?: any;
    handleBlur?: any;
    onRenameConfirmedButtonClicked?: any;
    cursorAtEnd?: boolean;
}) => {
    const textareaRef = useRef<HTMLTextAreaElement | null>(null);

    useEffect(() => {
        setTimeout(() => {
            if (textareaRef.current) {
                textareaRef.current.focus();
                if (props.cursorAtEnd) {
                    const length = textareaRef.current.value.length;
                    textareaRef.current.setSelectionRange(length, length);
                }
            }
        }, 0);
    }, [props.cursorAtEnd]);

    return (
        <div className={styles.wrap} onBlur={props.handleBlur}>
            <textarea
                ref={textareaRef}
                value={props.value}
                onChange={props.handleChange}
                onKeyDown={props.handleKeyDown}
                maxLength={props.maxLength}
                placeholder={props.placeholder}
                style={{
                    width: '100%',
                    maxHeight: '200px',
                    overflowY: 'auto',
                    resize: 'none',
                }}
            />
            <button onMouseDown={props.onRenameConfirmedButtonClicked}>
                <CheckIcon />
            </button>
        </div>
    );
};

export default TextEditable;
